import { render, staticRenderFns } from "./FilterItemTapirMk.vue?vue&type=template&id=537d6c12&scoped=true&"
import script from "./FilterItemTapirMk.vue?vue&type=script&lang=js&"
export * from "./FilterItemTapirMk.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemTapirMk.vue?vue&type=style&index=0&id=537d6c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d6c12",
  null
  
)

export default component.exports